import React from 'react';
import propTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Alert, Button } from 'reactstrap';

const getErrorMessage = error => {
  if (!error) return null;
  if (error.message) return error.message;
  if (error.error && error.error.message) return error.error.message;
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }
  if (error.response && error.response.data && error.response.data.error) {
    return error.response.data.error.message;
  }
  return 'Unable to load sales. Please try again.';
};

const SalesCursorPagination = ({ loadedCount, hasMore, nextCursor, isLoading, isFetching, error, onLoadMore, onRetry }) => {
  const errorMessage = getErrorMessage(error);
  const isBusy = isLoading || isFetching;
  if (!loadedCount && !errorMessage) return null;

  return (
    <div>
      {errorMessage && <Alert color="danger" className="mt-3 mb-0">{errorMessage}</Alert>}
      {((errorMessage && onRetry) || (!errorMessage && hasMore && nextCursor && !isBusy)) && (
        <div className="text-center mt-3">
          <Button
            color="secondary"
            size="sm"
            disabled={isLoading}
            onClick={() => (errorMessage
              ? (nextCursor ? onLoadMore(nextCursor) : onRetry())
              : onLoadMore(nextCursor))}
          >
            {errorMessage ? 'Retry' : 'Load more'}
          </Button>
        </div>
      )}
      {loadedCount > 0 && (
        <InfiniteScroll
          dataLength={loadedCount}
          hasChildren={loadedCount > 0}
          next={() => onLoadMore(nextCursor)}
          hasMore={Boolean(hasMore && nextCursor && !errorMessage && (!isFetching || isLoading))}
          scrollThreshold={0.95}
          loader={<div className="text-center mt-3">Loading more items...</div>}
        >
          <p className="pagination-summaries text-center mt-3 mb-0" role="status" aria-live="polite">
            {isLoading
              ? `Loading more items. ${loadedCount} items are currently loaded.`
              : errorMessage
              ? 'Unable to load more items.'
              : hasMore
                ? `Showing ${loadedCount} loaded items. Scroll to load more.`
                : `Showing all ${loadedCount} items.`}
          </p>
        </InfiniteScroll>
      )}
    </div>
  );
};

SalesCursorPagination.propTypes = {
  loadedCount: propTypes.number,
  hasMore: propTypes.bool,
  nextCursor: propTypes.string,
  isLoading: propTypes.bool,
  isFetching: propTypes.bool,
  error: propTypes.object,
  onLoadMore: propTypes.func.isRequired,
  onRetry: propTypes.func
};

SalesCursorPagination.defaultProps = {
  loadedCount: 0,
  hasMore: false,
  nextCursor: null,
  isLoading: false,
  isFetching: false,
  error: null,
  onRetry: null
};

export default SalesCursorPagination;
